<script lang="ts" setup>
defineProps<{
  image?: {
    url: {
      path: string
    }
    alt: {
      alt: string
    }
    title: string
  }
}>()

const { options } = defineBlokkli({
  bundle: 'image_svg',
  globalOptions: ['spacingTop', 'spacingBottom', 'backgroundColor'],
})

const paragraphClassList = computed(() => {

  const classList = []

  if (options.value.spacingTop) {
    classList.push(options.value.spacingTop)
  }

  if (options.value.spacingBottom) {
    classList.push(options.value.spacingBottom)
  }

  if (options.value.backgroundColor !== 'white') {
    classList.push(options.value.backgroundColor)
  }

  return classList
})
</script>

<template>
  <div class="etx-container Container" :class="paragraphClassList">
    <div class="etx-center Center">

      <div class="etx-media Media ">
        <MediaIcon :media="image" />
      </div>

    </div>
  </div>
</template>